import { type TFunction } from 'i18next'

export function getMessageBasedOnType(
	type: string | null,
	t: TFunction,
): string | null {
	switch (type) {
		case 'testResults':
			return t('templateMessage.summaryIpip')
	}

	return null
}
